// extracted by mini-css-extract-plugin
export default {"row":"Home_row__pBnPm","col":"Home_col__h9wC0","card":"Home_card__fZhgg"};